import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
  Typography,
} from "@mui/material";

// Define parentesco and parentescoMap at the top level
const parentesco = [
  { id: 1, parentesco: "Madre/Padre" },
  { id: 2, parentesco: "Hermano/Hermana" },
  { id: 3, parentesco: "Esposo/Esposa" },
  { id: 4, parentesco: "Hijo/Hija" },
  { id: 5, parentesco: "Abuelo/Abuela" },
  { id: 6, parentesco: "Sobrino/Sobrina" },
  { id: 7, parentesco: "Tío/Tía" },
  { id: 8, parentesco: "Otro" },
];

const parentescoMap = {};
parentesco.forEach((item) => {
  parentescoMap[item.id] = item.parentesco;
});

// Define formatDate at the top level
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const TablasEmail = ({ cliente, solicitud, reportePagos = [], difunto }) => {
  // 1. ESTO ES LO QUE TENÍAS (Mantenemos tus nombres de variables)
  const esServicio = solicitud?.tipo_plan === "servicio";
  const esUSD = reportePagos[0]?.metodo_pago === "USD";

  // 2. Aquí estaba la falla: definimos 'descuento' para que SIEMPRE exista
  // aunque sea 0, así la tabla no dice que "no está definido".
  const aplicaDescuento = esServicio && esUSD;
  const descuento = aplicaDescuento ? (reportePagos[0]?.monto_pagado * 0.2) : 0;

  // 3. Tu lógica de VES (Bolívares) para los campos bancarios
  const esFinanciadoVES = solicitud?.modalidad_pago === "financiado" && reportePagos[0]?.metodo_pago === "VES";

  return (
    <>
      {/* ================= CLIENTE ================= */}
      {cliente && (
        <Box sx={{ marginBottom: "10px" }}>
          <Typography
            sx={{ textAlign: "left", fontFamily: "Bakbak One, sans-serif", color: "#0A4575" }}
            variant="h6"
          >
            DATOS DEL CLIENTE
          </Typography>

          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#0A4575" }}>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Nombre</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Cédula</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Dirección</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Celular</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Correo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">{cliente.nombre}</TableCell>
                <TableCell align="center">{cliente.cedula}</TableCell>
                <TableCell align="center">{cliente.direccion}</TableCell>
                <TableCell align="center">{cliente.celular}</TableCell>
                <TableCell align="center">{cliente.email}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      )}

      {/* ================= SOLICITUD ================= */}
      {solicitud && (
        <Box>
          <Typography
            sx={{ textAlign: "left", fontFamily: "Bakbak One, sans-serif", color: "#0A4575" }}
            variant="h6"
          >
            DETALLES DE LA SOLICITUD
          </Typography>

          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#0A4575" }}>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Número de Solicitud</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Descripción</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Modalidad</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Cuotas</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Monto por Cuota</TableCell>
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Precio Plan</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">{solicitud.id}</TableCell>
                <TableCell align="center">{solicitud.descripcion}</TableCell>
                <TableCell align="center">{solicitud.modalidad_pago}</TableCell>
                <TableCell align="center">{solicitud.numero_cuotas || 0}</TableCell>
                <TableCell align="center">
                  ${solicitud.monto_por_cuota?.toFixed(2) || "0.00"}
                </TableCell>
                <TableCell align="center">
                  ${solicitud.precio_plan?.toFixed(2) || "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      )}

      {/* ================= REPORTE PAGOS ================= */}
      <Box sx={{ marginTop: "20px" }}>
        <Typography sx={{ fontFamily: "Bakbak One, sans-serif", color: "#0A4575" }} variant="h6">
          REPORTE DE PAGOS
        </Typography>

        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#0A4575" }}>
              <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Fecha</TableCell>
              <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Método de Pago</TableCell>
              <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Monto Pagado</TableCell>

              {/* Solo aparece si es Servicio + USD */}
              {aplicaDescuento && (
                <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Descuento</TableCell>
              )}

              {/* Lo que preguntaste al principio: agrupar varios TableCell */}
              {esFinanciadoVES && (
                <>
                  <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Tasa BCV</TableCell>
                  <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Banco Emisor</TableCell>
                  <TableCell sx={{ color: "#FFF", textAlign: "center" }}>Referencia de Pago</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell align="center">{formatDate(reportePagos[0]?.fecha_pago)}</TableCell>
              <TableCell align="center">{reportePagos[0]?.metodo_pago}</TableCell>
              <TableCell align="center">${reportePagos[0]?.monto_pagado?.toFixed(2)}</TableCell>

              {aplicaDescuento && (
                <TableCell align="center">${descuento.toFixed(2)}</TableCell>
              )}

              {esFinanciadoVES && (
                <>
                  <TableCell align="center">{reportePagos[0]?.tasa_bcv?.toFixed(2) || "N/A"}</TableCell>
                  <TableCell align="center">{reportePagos[0]?.banco_emisor || "N/A"}</TableCell>
                  <TableCell align="center">{reportePagos[0]?.referencia || "N/A"}</TableCell>
                </>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </>
  );
};